import { Stack } from '@mui/material';
import { SettingCard } from '@/components';
import ClassSettings from '@/components/editor/settings/ClassSettings';
import MenuSettingsBlock from '@/components/editor/settings/MenuSettingsBlock';

const DishSettings = () => {
  return (
    <Stack spacing={2}>
      <SettingCard title="Clase Css">
        <ClassSettings />
      </SettingCard>
      <SettingCard title="Menú">
        <MenuSettingsBlock />
      </SettingCard>
    </Stack>
  );
};

export default DishSettings;
